<template>
	<div class="col" style="align-items: center;">
		<img width="500" src="../../../public/404.gif" alt="">
	</div>
</template>

<script>
</script>

<style>
</style>
